import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isReset: null,
  name: null,
  description: null
};

const taxonomySlice = createSlice({
  name: 'reportBuilderSlice',
  initialState,
  reducers: {
    setIsReset: (state, action) => {
      state.isReset = action.payload;
  },
  setName: (state, action) => {
    state.name = action.payload;
  },
  setDescription: (state, action) => {
    state.description = action.payload;
  },
  clearFields: (state) => {
    state.name = null;
    state.description = null;
  },
  },
});

export const { setIsReset, setName, setDescription, clearFields } = taxonomySlice.actions;

export default taxonomySlice.reducer;
